@if (banner) {
<atx-media
  [media]="bannerMedia"
  [class.hidden]="bannerMedia !== activeBannerMedia"
  [videoPlayerProps]="videoPlayerProps"
  objectFit="cover"
></atx-media>
@if (activeBannerMedia?.type === mediaTypes.VIDEO) {
<fa-icon
  class="volume"
  (click)="toggleVideoVolume()"
  [icon]="videoPlayerProps.muted ? ['fas', 'volume-slash'] : ['fas', 'volume']"
></fa-icon>
} @for (media of bannerSecondaryMedias; track media) { @if (!(media.type ===
mediaTypes.VIDEO && media !== activeBannerMedia)) {
<atx-media
  [media]="media"
  [videoPlayerProps]="videoPlayerProps"
  [class.hidden]="media !== activeBannerMedia"
  objectFit="cover"
></atx-media>
} }
<div
  class="links-container d-flex flex-column justify-content-center"
  [style]="{ color: banner.style?.color || 'white' }"
>
  <h1 data-e2e="banner-title">{{ banner.title }}</h1>
  @for (link of banner.links; track link; let index = $index) { @if
  (getAnchorProps(link); as anchorProps) {
  <atx-anchor
    (mouseenter)="toggleBannerHover(link)"
    (mouseleave)="toggleBannerHover()"
    [href]="anchorProps.href"
    [routerLink]="anchorProps.routerLink"
    [queryParams]="anchorProps.queryParams"
    [newTab]="anchorProps.external"
    (linkClick)="onLinkClick(anchorProps, index, link)"
  >
    {{ link.label }}
  </atx-anchor>
  } }
</div>
@if (firstFullScreenLink) { @if (getAnchorProps(firstFullScreenLink.link); as
anchorProps) {
<atx-anchor
  class="full-link"
  (mouseenter)="toggleBannerHover(firstFullScreenLink.link)"
  (mouseleave)="toggleBannerHover()"
  [href]="anchorProps.href"
  [routerLink]="anchorProps.routerLink"
  [queryParams]="anchorProps.queryParams"
  [newTab]="anchorProps.external"
  (linkClick)="
    onLinkClick(
      anchorProps,
      firstFullScreenLink.index,
      firstFullScreenLink.link
    )
  "
></atx-anchor>
} } }
